import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import FinancesActions, { FinancesRedux, FinancesTypes } from '../Redux/FinancesRedux'
import { notificationFail } from '../Redux/NotificationActions'

const financesCrudObservable = createCRUDObservable({
  mainRedux: FinancesRedux,
  reduxPath: 'finances',
})

const financesExcelEpic = (action$, store, { Api }) =>
  action$.ofType(FinancesTypes.FinancesExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.finances.getFinancesExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            FinancesActions.FinancesExcelSuccess(),
          ]
        })
    ))

export const financesObservers = Object.assign({}, financesCrudObservable.observers, {})

export const financesEpic = combineEpics(
  financesCrudObservable.epic,
  financesExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/FinancesObservable.js